/* eslint-disable no-console */
import Api from "../../../api";
import { getPolygonPresenter } from "../presenters";
import { getPolygonSchema } from "../schemas";

const url = {
  PROVINSI: "/kabupaten",
  KABUPATEN: "/kabupaten",
  KECAMATAN: "/kecamatan",
};

const getPolygon = {
  state: {
    data: null,
    secondaryData: null,
    thirdaryData: null,
    fourthData: null,
  },
  reducers: {
    resetPolygon(state) {
      return {
        ...state,
        data: null,
        secondaryData: null,
        thirdaryData: null,
        fourthData: null,
      };
    },
    resetSecondaryPolygon(state) {
      return {
        ...state,
        secondaryData: null,
        thirdaryData: null,
        fourthData: null,
      };
    },
    resetThirdaryPolygon(state) {
      return {
        ...state,
        thirdaryData: null,
        fourthData: null,
      };
    },
    resetQuaternaryPolygon(state) {
      return {
        ...state,
        fourthData: null,
      };
    },
    setPolygonData(state, payload) {
      return {
        ...state,
        data: payload,
      };
    },
    setSecondaryData(state, payload) {
      return {
        ...state,
        secondaryData: payload,
      };
    },
    setThirdaryData(state, payload) {
      return {
        ...state,
        thirdaryData: payload,
      };
    },
    setSelectedKelurahan(state, payload) {
      const selected = { ...state.thirdaryData };
      return {
        ...state,
        fourthData: {
          type: "FeatureCollection",
          features: selected.features.filter(
            (feature) => feature.properties.id === payload
          ),
        },
      };
    },
  },
  effects: (dispatch) => ({
    async getPolygonKabupaten() {
      try {
        dispatch.notification.clearAll();
        dispatch.getPolygon.resetPolygon();

        const fetchResponse = await Api.get(`${url.PROVINSI}`);
        // console.log("Fetch response", fetchResponse.data);

        const schemaIsValid = await getPolygonSchema.isValid(
          fetchResponse.data
        );
        // console.log(getPolygonSchema.validate(fetchResponse.data));
        // console.log("Schema is valid?", schemaIsValid);

        if (schemaIsValid) {
          dispatch.getPolygon.setPolygonData(
            getPolygonPresenter(fetchResponse.data)
          );
        } else {
          dispatch.notification.setErrorMessage("Respon tidak sesuai");
        }
      } catch (error) {
        if (error.response) {
          // Request made and server responded
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);

          // Set error messages
          if (
            error.response.status === 404 &&
            error.response.data.error.code === "ResourceNotFound"
          ) {
            dispatch.notification.setErrorMessage("Laporan tidak ditemukan");
          } else {
            dispatch.notification.setErrorMessage(error.response.data.message);
          }
        } else if (error.request) {
          // The request was made but no response was received
          console.log(error.request);

          // Set error messages
          dispatch.notification.setErrorMessage(
            "Gagal melakukan permintaan data"
          );
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log(error.message);
        }
      }
    },
    async getPolygonKecamatanByKabId(id) {
      try {
        dispatch.notification.clearAll();
        dispatch.getPolygon.resetSecondaryPolygon();

        const fetchResponse = await Api.get(`${url.KABUPATEN}/${id}/kecamatan`);
        // console.log("Fetch response", fetchResponse.data);

        const schemaIsValid = await getPolygonSchema.isValid(
          fetchResponse.data
        );
        // console.log(getReportSchema.validate(fetchResponse.data));
        // console.log("Schema is valid?", schemaIsValid);

        if (schemaIsValid) {
          dispatch.getPolygon.setSecondaryData(
            getPolygonPresenter(fetchResponse.data)
          );
        } else {
          dispatch.notification.setErrorMessage("Respon tidak sesuai");
        }
      } catch (error) {
        if (error.response) {
          // Request made and server responded
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);

          // Set error messages
          if (
            error.response.status === 404 &&
            error.response.data.error.code === "ResourceNotFound"
          ) {
            dispatch.notification.setErrorMessage("Laporan tidak ditemukan");
          } else {
            dispatch.notification.setErrorMessage(error.response.data.message);
          }
        } else if (error.request) {
          // The request was made but no response was received
          console.log(error.request);

          // Set error messages
          dispatch.notification.setErrorMessage(
            "Gagal melakukan permintaan data"
          );
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log(error.message);
        }
      }
    },
    async getPolygonKelurahanByKecId(id) {
      try {
        dispatch.notification.clearAll();
        dispatch.getPolygon.resetThirdaryPolygon();

        const fetchResponse = await Api.get(`${url.KECAMATAN}/${id}/kelurahan`);
        // console.log("Fetch response", fetchResponse.data);

        const schemaIsValid = await getPolygonSchema.isValid(
          fetchResponse.data
        );
        // console.log(getReportSchema.validate(fetchResponse.data));
        // console.log("Schema is valid?", schemaIsValid);

        if (schemaIsValid) {
          dispatch.getPolygon.setThirdaryData(
            getPolygonPresenter(fetchResponse.data)
          );
        } else {
          dispatch.notification.setErrorMessage("Respon tidak sesuai");
        }
      } catch (error) {
        if (error.response) {
          // Request made and server responded
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);

          // Set error messages
          if (
            error.response.status === 404 &&
            error.response.data.error.code === "ResourceNotFound"
          ) {
            dispatch.notification.setErrorMessage("Laporan tidak ditemukan");
          } else {
            dispatch.notification.setErrorMessage(error.response.data.message);
          }
        } else if (error.request) {
          // The request was made but no response was received
          console.log(error.request);

          // Set error messages
          dispatch.notification.setErrorMessage(
            "Gagal melakukan permintaan data"
          );
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log(error.message);
        }
      }
    },
    async setSelectedKelurahanAsync(id) {
      await dispatch.notification.clearAll();
      await dispatch.getPolygon.resetQuaternaryPolygon();
      await dispatch.getPolygon.setSelectedKelurahan(id);
    },
  }),
};

export default getPolygon;
